module.exports = __webpack_public_path__ + "img/down-icon.1016d5bd.png";